import UPSPICO		from "upspico";

class UPS extends UPSPICO {
  constructor(p) {
    super(p);

    this.id = "-";
    this.status = "uninitialized";
  }
  async open() {
    await super.open();
    this.__previousPowerMode = await this.getPowerMode();
  }
  async initialize() {
    try {
      await this.open();
      this.id = `UPSPICO Firmware Version: 0x${(await this.getFirmwareVersion()).toString(16).toUpperCase()}, PCB Version: 0x${(await this.getPCBVersion()).toString(16).toUpperCase()}, Bootloader Version: 0x${(await this.getBootloaderVersion()).toString(16).toUpperCase()}`;
      this.status = "Ok";
    } catch(e) {
      this.status = "Failed: "+e.message;
      throw e;
    }
  }
  async update() {
    try {
      this.power_mode = await this.getPowerMode();
      this.battery_voltage = await this.getBatteryVoltage();
      this.battery_percentage = await this.getBatteryPercentage();
      this.ntc_temperature = await this.getNTCTemperature();
      this.to92_temperature = await this.getTO92Temperature();
      this.system_voltage = await this.getSystemVoltage();
      this.external_voltage = await this.getExternalVoltage();
      
      if (this.power_mode != this.__previousPowerMode) {
        if (this.power_mode == UPSPICO.POWERMODE_CABLE) {
          this.dispatchEvent( new CustomEvent("onpower", {detail: null}) );
          if (this.timer) clearTimeout(this.timer);
        } else {
          this.dispatchEvent( new CustomEvent("onbattery", {detail: null}) );
          this.timer = setTimeout(function() {
            this.dispatchEvent( new CustomEvent("onshutdown", {detail: null}) );
          }.bind(this), 10000);
        }
      }
      this.__previousPowerMode = this.power_mode;
      
      this.status = "Ok";
    } catch(e) {
      this.status = "Failed: "+e.message;
      throw e;
    }
  }
  toJSON() {
    try {
      return({
        id: this.id,
        status: this.status,
        power_mode: this.power_mode,
        battery_voltage: this.battery_voltage,
        battery_percentage: this.battery_percentage,
        ntc_temperature: this.ntc_temperature,
        to92_temperature: this.to92_temperature,
        system_voltage: this.system_voltage,
        external_voltage: this.external_voltage
      });
    } catch(e) {
      return({
        id: this.id,
        status: "Failed",
        power_mode: "-",
        battery_voltage: "-",
        battery_percentage: "-",
        ntc_temperature: "-"
      });
    }
  }
}

export default UPS;